import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall, handleErrorMessage } from "../../../utils/request";
import { EventBus } from "../../../event-bus";
import * as emConsts from "./constants";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";
import consts from "../../../_consts";
import * as storeUtils from "../../../utils/store-handler";

export const state = {
  employers: [],
  allEmployers: [],
  employer: {},
  pagination: {
    count: 10,
    total: 0
  },
  providers: {},
  sftps: {},
  ssoOIDCConfig: {
    ProviderName: "",
    IdpIdentifiers: "",
    ProviderDetails: {
      client_id: "",
      client_secret: "",
      attributes_request_method: "",
      authorize_scopes: "",
      oidc_issuer: ""
    },
    AttributeMapping: {
      "custom:external_id": "",
      family_name: "",
      given_name: ""
    }
  },
  ssoSAMLConfig: {
    ProviderName: "",
    IdpIdentifiers: "",
    metadata_filename: "",
    ProviderDetails: {
      MetadataURL: "",
      MetadataFile: ""
    },
    AttributeMapping: {
      "custom:external_id": "",
      family_name: "",
      given_name: ""
    }
  },
  ssoType: null
};

export const getters = {
  [emConsts.GETTERS_LIST_EMPLOYER]: state => {
    return state.employers;
  },
  [emConsts.GETTERS_LIST_ALL_EMPLOYER]: state => {
    return state.allEmployers;
  },
  [emConsts.GETTERS_EMPLOYER_DETAIL]: state => {
    return state.employer;
  },
  [emConsts.GETTERS_EMPLOYERS_PAGINATION]: state => {
    return state.pagination;
  },
  [emConsts.GETTERS_PROVIDERS]: state => {
    return state.providers;
  },
  [emConsts.GETTERS_LIST_SFTP]: state => {
    return state.sftps;
  },
  [emConsts.GETTERS_SSO_OIDC_CONFIG]: state => {
    return state.ssoOIDCConfig;
  },
  [emConsts.GETTERS_SSO_SAML_CONFIG]: state => {
    return state.ssoSAMLConfig;
  },
  [emConsts.GETTERS_SSO_TYPE_CONFIG]: state => {
    return state.ssoType;
  }
};

export const actions = {
  [emConsts.ACTION_GET_EMPLOYER_LIST]: ({ commit }, options) => {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().employers.getEmployersCompact,
        buildOptions("GET", options),
        commit
      )
        .then(response => {
          if (response.data) {
            commit(emConsts.MUTATION_SET_EMPLOYER_LIST, response);
            resolve(response);
          }
        })
        .catch(error => reject(error));
    });
  },
  [emConsts.ACTION_GET_ALL_EMPLOYER_LIST]: ({ commit }, options) => {
    makeCall(
      getEndPoints().employers.getEmployersCompact,
      buildOptions("GET", options),
      commit
    ).then(response => {
      if (response.data) {
        commit(emConsts.MUTATION_SET_ALL_EMPLOYER_LIST, response);
        if (options.callback) {
          options.callback();
        }
      }
    });
  },
  [emConsts.ACTION_GET_EMPLOYER]: ({ commit }, options) => {
    const detailUrl = getEndPoints().employers.detail.replace(
      ":id",
      options.id
    );
    makeCall(detailUrl, buildOptions("GET", options), commit).then(
      response => {
        if (response.data) {
          commit(emConsts.MUTATION_SET_EMPLOYER, response);
        }
        if (options.callback) {
          options.callback(response);
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  },
  [emConsts.ACTION_SET_EMPTY_EMPLOYER]: ({ commit }) => {
    commit(emConsts.MUTATION_SET_EMPTY_EMPLOYER);
  },
  [emConsts.ACTION_ADD_EMPLOYER]: ({ commit }, options) => {
    makeCall(
      getEndPoints().employers.add,
      buildOptions("POST", options.data),
      commit
    ).then(
      response => {
        if (response.error) {
          options.errorHandling(response.error);
        } else if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback(response);
        }
      },
      response => {
        const error = storeUtils.handleErrorMessage(response);
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (error && error.message) || "Something went wrong"
        );
      }
    );
  },
  [emConsts.ACTION_ADD_CLIENT_SFTP]: ({ commit }, options) => {
    makeCall(
      getEndPoints().clientsftp.add,
      buildOptions("POST", options.data),
      commit
    )
      .then(response => {
        if (response.error) {
          options.errorHandling(response.error);
        } else if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback(response);
        }
      })
      .catch(function({ response }) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.error.message.error.message) ||
            "Something went wrong"
        );
      });
  },
  [emConsts.ACTION_GET_CLIENT_SFTP]: ({ commit }, options) => {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().employers.getClientSftp.replace(":id", options.id),
        buildOptions("GET", {}),
        commit
      )
        .then(response => {
          resolve(response);
        })
        .catch(function({ response }) {
          EventBus.$emit(
            EVENT_ERROR_TOAST_MESSAGE,
            (response.data && response.data.message) || "Something went wrong"
          );
          reject(response);
        });
    });
  },
  [emConsts.ACTION_EDIT_CLIENT_SFTP]: ({ commit }, options) => {
    makeCall(
      getEndPoints().clientsftp.edit.replace(":client_sftp_id", options.id),
      buildOptions("PUT", options.data),
      commit
    )
      .then(response => {
        if (response.error) {
          options.errorHandling(response.error);
        } else if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback(response);
        }
      })
      .catch(function({ response }) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.error.message.error.message) ||
            "Something went wrong"
        );
      });
  },
  [emConsts.ACTION_EDIT_EMPLOYER]: ({ commit }, options) => {
    const detailUrl = getEndPoints().employers.edit.replace(":id", options.id);
    makeCall(detailUrl, buildOptions("PUT", options.data), commit).then(
      response => {
        if (response.error) {
          options.errorHandling(response.error);
        } else if (options.callback) {
          // Move emit event to callback function, in order to update subgroup first, then emit result - Moved to line 222
          options.callback(response);
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  },
  [emConsts.ACTION_DELETE_EMPLOYER]: ({ dispatch, commit }, employerItem) => {
    const deleteUrl = getEndPoints().employers.deleteEmployer.replace(
      ":id",
      employerItem.id
    );
    makeCall(deleteUrl, buildOptions("DELETE", {}), commit)
      .then(() => {
        dispatch(
          emConsts.ACTION_GET_EMPLOYER_LIST,
          JSON.parse(localStorage.getItem(consts.LOCAL_STORE.pagingOptions))
        );
        EventBus.$emit(EVENT_TOAST_MESSAGE, "Delete employer successful");
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },
  [emConsts.ACTION_GET_PROVIDERS]: ({ commit }) => {
    const getProviderUrl = getEndPoints().employers.getProvider;
    makeCall(getProviderUrl, buildOptions("GET", {}), commit)
      .then(response => {
        if (response.error) {
          EventBus.$emit(
            EVENT_ERROR_TOAST_MESSAGE,
            response.error.message || "Something went wrong"
          );
        } else {
          commit(emConsts.MUTATION_SET_PROVIDERS, response);
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },
  [emConsts.ACTION_GET_LIST_SFTP]: ({ dispatch, commit }, options) => {
    const getProviderUrl = getEndPoints().clientsftp.getList;
    makeCall(getProviderUrl, buildOptions("GET", options), commit)
      .then(response => {
        if (response.error) {
          EventBus.$emit(
            EVENT_ERROR_TOAST_MESSAGE,
            response.error.message || "Something went wrong"
          );
        } else {
          commit(emConsts.MUTATION_SET_LIST_SFTP, response);
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },
  [emConsts.ACTION_ADD_SUBGROUP]: ({ dispatch, commit }, options) => {
    const getProviderUrl = getEndPoints().employers.syncMultiSubgroup.replace(
      ":employer_id",
      options.employer_id
    );
    return new Promise((resolve, reject) => {
      makeCall(getProviderUrl, buildOptions("PUT", options.data), commit)
        .then(response => {
          if (response && response.error) {
            EventBus.$emit(
              EVENT_ERROR_TOAST_MESSAGE,
              response.error.message || "Something went wrong"
            );
          } else {
            EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
            resolve(options.successMessage);
          }
        })
        .catch(function(response) {
          reject(response);
          EventBus.$emit(
            EVENT_ERROR_TOAST_MESSAGE,
            (response.data && response.data.message) || "Something went wrong"
          );
        });
    });
  },

  [emConsts.ACTION_ADD_IDP]: ({ commit }, options) => {
    const url = getEndPoints().employers.addIdp.replace(
      ":employer_id",
      options.employer_id
    );
    return new Promise((resolve, reject) => {
      makeCall(
        url,
        buildOptions("POST", options.data, {
          headers: { "Content-Type": "multipart/form-data" }
        }),
        commit
      )
        .then(response => {
          if (response && response.error) {
            handleErrorMessage(response.error);
          } else {
            EventBus.$emit(
              EVENT_TOAST_MESSAGE,
              options.successMessage || "Update IDP successfully."
            );
            response.data.isEdit = true;
            commit(emConsts.MUTATION_SET_SSO_CONFIG, response);
            resolve(options.successMessage);
            if (typeof options.callback === "function") {
              options.callback();
            }
          }
        })
        .catch(function(response) {
          reject(response);
          EventBus.$emit(
            EVENT_ERROR_TOAST_MESSAGE,
            (response.data && response.data.message) || "Something went wrong"
          );
        });
    });
  },

  [emConsts.ACTION_UPDATE_IDP]: ({ commit }, options) => {
    const url = getEndPoints()
      .employers.updateIdp.replace(":employer_id", options.employer_id)
      .replace(":provider_name", options.provider_name);
    return new Promise((resolve, reject) => {
      makeCall(
        url,
        buildOptions("POST", options.data, {
          headers: { "Content-Type": "multipart/form-data" }
        }),
        commit
      )
        .then(response => {
          if (response && response.error) {
            handleErrorMessage(response.error);
          } else {
            EventBus.$emit(
              EVENT_TOAST_MESSAGE,
              options.successMessage || "Update IDP successfully."
            );
            resolve(options.successMessage);
            if (typeof options.callback === "function") {
              options.callback();
            }
          }
        })
        .catch(function(response) {
          reject(response);
          EventBus.$emit(
            EVENT_ERROR_TOAST_MESSAGE,
            (response.data && response.data.message) || "Something went wrong"
          );
        });
    });
  },

  [emConsts.ACTION_GET_IDP]: ({ commit }, options) => {
    const url = getEndPoints()
      .employers.getIdp.replace(":employer_id", options.employer_id)
      .replace(":provider_name", options.provider_name);
    return new Promise((resolve, reject) => {
      makeCall(url, buildOptions("GET", {}), commit)
        .then(response => {
          if (response && response.error) {
            EventBus.$emit(
              EVENT_ERROR_TOAST_MESSAGE,
              response.error.message || "Something went wrong"
            );
            resolve(response);
          } else {
            response.data.provider_enable = options.provider_enable;
            response.data.metadata_filename = options.metadata_filename || "";
            response.data.isEdit = true;
            commit(emConsts.MUTATION_SET_SSO_CONFIG, response);
            if (response && response.data) {
              resolve(response.data);
            }
          }
        })
        .catch(function(response) {
          reject(response);
          EventBus.$emit(
            EVENT_ERROR_TOAST_MESSAGE,
            (response.data && response.data.message) || "Something went wrong"
          );
        });
    });
  },

  [emConsts.ACTION_SET_ENABLE_SSO]: ({ commit }, options) => {
    const url = getEndPoints()
      .employers.enableSSO.replace(":employer_id", options.employer_id)
      .replace(":value", options.value);
    return new Promise((resolve, reject) => {
      makeCall(url, buildOptions("PUT", {}), commit)
        .then(response => {
          if (response && response.error) {
            EventBus.$emit(
              EVENT_ERROR_TOAST_MESSAGE,
              response.error.message || "Something went wrong"
            );
          } else {
            EventBus.$emit(
              EVENT_TOAST_MESSAGE,
              options.successMessage || options.value
                ? "Enable SSO successfully"
                : "Disable SSO successfully."
            );
            resolve(response);
            if (typeof options.callback === "function") {
              options.callback(response);
            }
          }
        })
        .catch(function(response) {
          reject(response);
          EventBus.$emit(
            EVENT_ERROR_TOAST_MESSAGE,
            (response.data && response.data.message) || "Something went wrong"
          );
        });
    });
  },
};

export const mutations = {
  [emConsts.MUTATION_SET_EMPLOYER_LIST]: (state, employers) => {
    state.employers = employers;
    // state.pagination = employers.meta ? {
    //   ...state.pagination,
    //   ...{count: employers.meta.pagination.count,
    //     total: employers.meta.pagination.total}} : state.pagination;
  },
  [emConsts.MUTATION_SET_ALL_EMPLOYER_LIST]: (state, data) => {
    state.allEmployers = data;
  },
  [emConsts.MUTATION_SET_EMPLOYER]: (state, employer) => {
    state.employer = employer.data;
  },
  [emConsts.MUTATION_SET_EMPTY_EMPLOYER]: state => {
    state.employer = {};
  },
  [emConsts.MUTATION_SET_PROVIDERS]: (state, response) => {
    state.providers = response || {};
  },
  [emConsts.MUTATION_SET_LIST_SFTP]: (state, response) => {
    state.sftps = response || {};
  },
  [emConsts.MUTATION_SET_SSO_CONFIG]: (state, payload) => {
    if (payload && payload.data) {
      switch (payload.data.ProviderType) {
        case "OIDC":
          state.ssoOIDCConfig = payload.data;
          if (payload.data.provider_enable === 1) {
            state.ssoType = "OIDC";
          }
          break;
        case "SAML":
          state.ssoSAMLConfig = payload.data;
          if (payload.data.provider_enable === 1) {
            state.ssoType = "SAML";
          }
          break;
        default:
          break;
      }
    } else {
      (state.ssoOIDCConfig = {
        ProviderName: "",
        IdpIdentifiers: "",
        ProviderDetails: {
          client_id: "",
          client_secret: "",
          attributes_request_method: "",
          authorize_scopes: "",
          oidc_issuer: ""
        },
        AttributeMapping: {
          "custom:external_id": "",
          family_name: "",
          given_name: ""
        }
      }),
        (state.ssoSAMLConfig = {
          ProviderName: "",
          IdpIdentifiers: "",
          metadata_filename: "",
          ProviderDetails: {
            MetadataURL: "",
            MetadataFile: ""
          },
          AttributeMapping: {
            "custom:external_id": "",
            family_name: "",
            given_name: ""
          }
        });
      state.ssoType = null;
    }
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/employers/index.js